"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UwFailurePaymentReasonPanelWidget = void 0;
var React = require("react");
var HeadsUpPanel_1 = require("../../components/HeadsUpPanel");
var components_1 = require("@athena-portal/components");
var BasePaymentReasonPanel_1 = require("./BasePaymentReasonPanel");
var moment = require("moment");
var UwFailurePaymentReasonPanelWidget = exports.UwFailurePaymentReasonPanelWidget = /** @class */ (function (_super) {
    __extends(UwFailurePaymentReasonPanelWidget, _super);
    function UwFailurePaymentReasonPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.allDrivers = _this.props.interaction.uistate.drivers;
        _this.renderPaymentReasonMessage = function () {
            if (_this.state.policies && _this.state.policies.length > 0 && _this.state.subscription) {
                var interaction = _this.props.interaction;
                var displayDriverMessage = React.createElement("div", null, _this.wordingRemoveDriversIntro());
                var displayMessage = React.createElement("div", null, _this.wordingForRemovalOfDriver());
                var wordingForHeadsUpPanel = React.createElement("div", { className: "text-center" },
                    displayDriverMessage,
                    React.createElement("div", { className: "pb-2" }, _this.amountToDisplay()),
                    displayMessage);
                return (React.createElement(React.Fragment, null,
                    React.createElement(HeadsUpPanel_1.HeadsUpPanel, { wordingHtml: wordingForHeadsUpPanel, interaction: interaction, subscription: _this.state.subscription, policies: _this.state.policies })));
            }
            else {
                return "";
            }
        };
        _this.wordingRemoveDriversIntro = function () {
            var interaction = _this.props.interaction;
            var introMessage = "Due to the changes made we are no longer able to insure";
            var ending = "and as such will be removing them from the ";
            var message = "";
            var mtaStartDate = " from " + moment(interaction.headerInfo.startDate).format("DD MMM YYYY");
            var policies = "policy";
            if (interaction.childInteractions && interaction.childInteractions.length > 1) {
                policies = "policies";
            }
            if (_this.allDrivers.length == 1) {
                message = "".concat(introMessage, " ").concat(_this.allDrivers[0].firstName, " ").concat(_this.allDrivers[0].lastName, " ").concat(ending, " ").concat(mtaStartDate, ".");
            }
            else if (_this.allDrivers.length > 1) {
                var driverMessage = " ";
                for (var i = 0; i < _this.allDrivers.length; i++) {
                    var comma = ", ";
                    if (i == _this.allDrivers.length - 1) {
                        comma = "";
                    }
                    driverMessage = driverMessage + _this.allDrivers[i].firstName + " " + _this.allDrivers[i].lastName + comma;
                }
                message = "".concat(introMessage, " ").concat(driverMessage, " ").concat(ending, " ").concat(policies, " ").concat(mtaStartDate, ".");
            }
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, message)));
        };
        _this.wordingForRemovalOfDriver = function () {
            var genericMessage = "for the changes you have made";
            window.sessionStorage.setItem("mtaHeadsUpMessageText", "genericMessage");
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, genericMessage)));
        };
        _this.state = {
            policies: [],
            policiesLoaded: false,
            party: null,
            partyLoaded: false,
            subscriptionLoaded: false,
            subscription: null
        };
        return _this;
    }
    UwFailurePaymentReasonPanelWidget.prototype.render = function () {
        var loading = !(this.state.policiesLoaded && this.state.partyLoaded && this.state.subscriptionLoaded);
        return (React.createElement(React.Fragment, null,
            this.renderPaymentReasonMessage(),
            React.createElement(components_1.Overlay, { show: loading })));
    };
    UwFailurePaymentReasonPanelWidget = __decorate([
        components_1.authorize,
        __metadata("design:paramtypes", [Object])
    ], UwFailurePaymentReasonPanelWidget);
    return UwFailurePaymentReasonPanelWidget;
}(BasePaymentReasonPanel_1.BasePaymentReasonPanel));
//# sourceMappingURL=UwFailurePaymentReasonPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/payments/UwFailurePaymentReasonPanelWidget.js
// module id = 3458
// module chunks = 0